import getFiredAlertsForMonitors from './get-fired-alerts-for-monitors';
import getPlaybook from './get-playbook';
import listPlaybooks from './list-playbooks';
import runPlaybook from './run-playbook';
import postFindingsToEnrichmentThread from './post-findings-to-enrichment-thread';
import testAction from './test-action';
import fetchTeleportContext from './fetch-teleport-context';
import getAlert from './get-alert';
import getPlaybookCases from './get-tuning-cases';
import { ToolDefinition } from '../tool-definition';

const tools: ToolDefinition[] = [
  getFiredAlertsForMonitors,
  getPlaybook,
  listPlaybooks,
  runPlaybook,
  postFindingsToEnrichmentThread,
  testAction,
  fetchTeleportContext,
  getAlert,
  getPlaybookCases,
];

export default tools;
